<div class="center">
  <router-outlet></router-outlet>
</div>